import React, { useRef } from "react";
import { Provider, createStore } from "jotai";

export type PageStoreScope =
  | "remote-client"
  | "vehicle"
  | "webrtc-sender"
  | "test-lab"
  | "display-left"
  | "display-right"
  | "admin";

interface PageStoreProviderProps {
  children: React.ReactNode;
  scope: PageStoreScope;
}

export default function PageStoreProvider({
  children,
  scope: _scope,
}: PageStoreProviderProps) {
  const storeRef = useRef<ReturnType<typeof createStore> | null>(null);

  if (!storeRef.current) {
    storeRef.current = createStore();
  }

  return <Provider store={storeRef.current}>{children}</Provider>;
}
